import styled from "styled-components";
import { breakpointPixels } from "../css/breakpoints";

export default styled.h1`
  @media (max-width: ${breakpointPixels.md}) {
    margin-bottom: 0.75rem;
  }
  margin-bottom: 1.5rem;
`;
